// -- One animation loop drives every audio meter. Throttled, they all draw on the same frame:
// -- one canvas update per interval for the page, not one per meter on frames of its own.

export const MeterLoop = {

    intervalMs: 0,     // 0: every frame

    _fns: new Set(),
    _raf: 0,
    _last: 0,

    // -- fn(now, dt): rAF time (ms) and seconds since the previous draw (0 on a fresh start, ≤ 0.1)
    add(fn){
        this._fns.add(fn);
        if (!this._raf) this._raf = requestAnimationFrame(tick);
    },

    remove(fn){
        this._fns.delete(fn);
        if (this._fns.size || !this._raf) return;
        cancelAnimationFrame(this._raf);
        this._raf = 0;
        this._last = 0;
    },
};

function tick(now){

    const m = MeterLoop;
    m._raf = requestAnimationFrame(tick);

    // -- frame times jitter around the period: the allowance keeps 15 Hz on every 4th 60 Hz frame
    if (m._last && now - m._last < m.intervalMs - 2) return;
    const dt = m._last ? Math.min(0.1, (now - m._last) / 1000) : 0;
    m._last = now;

    for (const fn of m._fns) fn(now, dt);
}
